<template>
  <span
    v-if="currentNumber > 0"
    class="rounded-full bg-ambi-orange text-white w-5 h-5 inline-flex items-center justify-center"
    >{{ currentNumber }}</span
  >
</template>

<script>
export default {
  props: {
    from: {
      type: Number,
      default: 5
    }
  },
  data() {
    return {
      currentNumber: this.from,
      interval: null
    }
  },
  mounted() {
    if (this.currentNumber) {
      this.interval = setInterval(() => {
        this.currentNumber -= 1
      }, 1050)
    }

    if (this.currentNumber <= 0) {
      clearInterval(this.interval)
    }
  }
}
</script>

<style lang="scss" scoped></style>
